import React, { useState, useEffect } from "react";
import "./Laporan.css";
// import Header from "../../components/header/Header";
import imgHeader from "../../assets/image/img-header.png";
import { Accordion, AccordionItem } from "react-accessible-accordion";
import imgDoc from "../../assets/image/img-pdf.png";
import imgDownload from "../../assets/image/img-download.png";
import imgLaporan from "../../assets/image/img-laptop.png";
import file from "../../assets/image/ZABBIX_PRINT.pdf";
import { Header, Banner, Good } from "../../components/joinComponents";
import { Helmet } from "react-helmet";
import AOS from "aos";
import arrow1 from "../../assets/image/arrow-up.svg";
import arrow2 from "../../assets/image/arrow-down.svg";
import "aos/dist/aos.css";

const Laporan = () => {
  const header = {
    title: "Laporan",
    description: "Kampung Mundu",
    img: imgHeader,
  };

   const banners = {
     description: "Pilar Transparansi untuk Kemajuan Bersama.",
   };
 
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease",
    });
  }, []);

 

  // State untuk mengelola setiap accordion
  const [accordions, setAccordions] = useState([
    {
      id: 1,
      title: "Laporan Bulanan",
      isOpen: true,
    }, // Terbuka secara default
    {
      id: 2,
      title: "Laporan Tahunan",
      isOpen: false,
    }, // Tertutup secara default
  
  ]);

   const laporanData = [
     {
       id: 1,
       date: "22/10/2023",
       type: "Renovasi Masjid",
       file: file,
       category: "bulanan",
     },
     {
       id: 2,
       date: "22/10/2023",
       type: "Kegiatan kerja bakti",
       file: file,
       category: "bulanan",
     },
   ];



  // Fungsi untuk mengelola toggle accordion
  const toggleAccordion = (id) => {
    const updatedAccordions = accordions.map((accordion) => {
      if (accordion.id === id) {
        return { ...accordion, isOpen: !accordion.isOpen };
      } else {
        return { ...accordion, isOpen: false }; // Menutup accordion yang lainnya
      }
    });
    setAccordions(updatedAccordions);
  };


  const dataContentLaporan = [
    {
      description:
        "Laporan ini disusun secara berkala, biasanya setiap tahun, untuk memberikan gambaran yang jelas tentang penerimaan dan pengeluaran keuangan kampung. Laporan ini merupakan alat vital dalam mengelola sumber daya finansial kampung dan memberikan transparansi kepada semua anggota kampung tentang bagaimana uang dan aset kampung digunakan.",
      img: imgLaporan,
    },
  ];

   const downloadPDF = (laporan) => {
     const link = document.createElement("a");
     link.href = file;
     link.download = `laporan_${laporan.type
       .replace(/\s+/g, "_")
       .toLowerCase()}.pdf`;
   };


  return (
    <>
      <Helmet>
        <title>
          Laporan Keuangan Kami: Dengan adanya laporan Keuangan yang kita
          berikan akan menjadikan transparansi kepada warga setempat.
        </title>
        <meta
          name='keyword'
          content='mundu, mundu 1902, moendoe, moendoe 1902, kampung digital, website desa, web keren, lubang buaya, jakarta timur, kampung keren'
        />
        <meta
          name='description'
          content='Laporan ini disusun secara berkala, biasanya setiap tahun, untuk memberikan gambaran yang jelas tentang penerimaan dan pengeluaran keuangan kampung. Laporan ini merupakan alat vital dalam mengelola sumber daya finansial kampung dan memberikan transparansi kepada semua anggota kampung tentang bagaimana uang dan aset kampung digunakan.'
        />
        <meta
          name='og:title'
          content='Laporan Keuangan Kami: Dengan adanya laporan Keuangan yang kita berikan akan menjadikan transparansi kepada warga setempat.'
        />
        <meta
          name='og:description'
          content='Laporan ini disusun secara berkala, biasanya setiap tahun, untuk memberikan gambaran yang jelas tentang penerimaan dan pengeluaran keuangan kampung. Laporan ini merupakan alat vital dalam mengelola sumber daya finansial kampung dan memberikan transparansi kepada semua anggota kampung tentang bagaimana uang dan aset kampung digunakan.'
        />
      </Helmet>
      <Header data={header} />
      <div className='containerLaporan w-full flex flex-col justify-evenly lg:px-10 sm:px-5'>
        <div className='box-berita flex flex-col lg:mt-16 sm:mt-5'>
          <p className='title-history w-fit lg:ml-16 sm:ml-5 md:ml-16 p-3 lg:text-7xl md:text-5xl'>
            Laporan Keuangan
          </p>
          {/* <p className='title-history w-fit px-3'>{dataCard[0].title}</p> */}
          <p className='title-berita w-fit p-3 lg:text-7xl md:text-5xl'>
            Kampung Mundu
          </p>
        </div>

        {dataContentLaporan.map((data, index) => (
          <div key={index} className='col-berita-group relative'>
            <div className='box-article-laporan mb-5 flex justify-between w-full lg:flex-row sm:flex-col-reverse md:flex-row sm:mt-5 lg:items-start sm:items-center'>
              <article className='flex w-full flex-col mt-10 lg:gap-5 sm:gap-4 sm:mt-5 '>
                <p className='max-w-screen-md'>{data.description}</p>
              </article>

              <img
                src={data.img}
                alt=''
                srcset=''
                className='img-laproran-content sm:max-w-xs lg:max-w-fit md:max-w-screen-md sm:max-w-xs'
              />
            </div>
          </div>
        ))}

        <Accordion className='_accordionContainer'>
          {accordions.map((accordion) => (
            <AccordionItem key={accordion.id}>
              <h3
                onClick={() => toggleAccordion(accordion.id)}
                className={`accordion-title ${accordion.isOpen ? "open" : ""}`}
              >
                {accordion.title}
                <img
                   src={accordion.isOpen ? arrow2 : arrow1}
                   alt="arrow icon"
                   className='arrow-icon'
                 />
              </h3>
              {accordion.isOpen && (
                <div className='boxLaporan'>
                  {laporanData
                    .filter((laporan) => {
                      // Sesuaikan dengan kategori yang diinginkan (bulanan atau tahunan)
                      return accordion.title.toLowerCase() === "laporan bulanan"
                        ? laporan.category === "bulanan"
                        : laporan.category === "tahunan";
                    })
                    .map((laporan) => (
                      <div className='rowLaporan' key={laporan.id}>
                        <div className='contentDoc'>
                          <img src={imgDoc} alt='' className='img-laporan' />
                          <a
                            href={laporan.file}
                            target='_blank'
                            rel='noopener noreferrer'
                            download={`${laporan.type
                              .replace(/\s+/g, "_")
                              .toLowerCase()}.pdf`}
                          >
                            <img
                              src={imgDownload}
                              alt=''
                              className='img-download'
                              style={{ cursor: "pointer" }}
                            />
                          </a>
                        </div>
                        <div className='articleLaporan'>
                          <p className='accordion-date'>{laporan.date}</p>
                          <p className='report-type'>{laporan.type}</p>
                          {/* <button onClick={() => downloadPDF(laporan)}>
                          Download PDF
                        </button> */}
                        </div>
                      </div>
                    ))}
                </div>
              )}
            </AccordionItem>
          ))}
        </Accordion>
      </div>
      {/* <SliderText /> */}
      <Banner data={banners}/>
      <Good />
    </>
  );
};

export default Laporan;
